$(() => {

    'use strict';

    /*============================================
        Initializations
    ==============================================*/

    // AJAX
    require('./modules/ajax.js');

    // Bootstrap
    require('./modules/bootstrap.js');

    // Navigation Header
    require('./modules/header.js');

    /*============================================
        Event Listeners
    ==============================================*/

    // Unused links
    $(document).on('click', 'a[href="#"]', function (e) {
        e.preventDefault();
    });

    // Phone Number Dropdown
    if ($('.input-phone:not(.ignore)').length > 0) {
        $('.input-phone:not(.ignore)').each((index, element) => {
            $(element).customPhoneInput();
        });
    }

    // Preloader
    $(window).on('load', function () {
        $(window).trigger('scroll');
        $('body').attr('data-loaded', true);
    });

    setTimeout(() => {
        $('body').attr('data-loaded', true);
    }, 1500);

    // Locale cookie
    if (!$.getCookie('locale_cookie')) {
        $.setCookie('locale_cookie', null, 1);
        $('#modal-locale').modal('show');
    }
});
